import { createSelector } from '@reduxjs/toolkit';
export const selectOverlayState = ({
  overlayDisplayConfigState
}) => overlayDisplayConfigState;
export const selectOverlayDisplayConfig = createSelector(selectOverlayState, ({
  appOverlayDisplayConfig
}) => appOverlayDisplayConfig);
export const selectIsOverlayOpen = createSelector(selectOverlayState, ({
  isOverlayOpen
}) => isOverlayOpen);
export const selectShouldShowNav = createSelector(selectOverlayState, ({
  shouldShowNav
}) => shouldShowNav);
export const selectShouldShowToolbar = createSelector(selectOverlayState, ({
  shouldShowToolbar
}) => shouldShowToolbar);